module.exports = __webpack_public_path__ + "img/small_whale27.73144582.jpg";